import {Button} from '../button/button';
import {Song} from '../song/song';
import css from './play-state.module.scss';
import {PlayStateProps} from './play-state.types';

export const PlayState = (props: PlayStateProps): JSX.Element => {
	return (
		<div className={css.container}>
			<div className={css.songContainer}>
				<Song {...props.song} played={undefined} />
			</div>
			<div className={css.buttonsContainer}>
				<Button onClick={props.onYesClick} name="Yes" color="green" icon="/img/yes-icon.svg" />
				<Button onClick={props.onNoClick} name="No" color="red" icon="/img/no-icon.svg" />
			</div>
		</div>
	);
};
